"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const native_1 = require("styled-components/native");
const react_native_1 = require("react-native");
const S = __importStar(require("./Toggle.styles"));
exports.default = (props) => {
    const { enabled = false, onChange, accessibilityHint, accessibilityLabel, testID, } = props;
    const fadeAnim = react_1.useRef(new react_native_1.Animated.Value(enabled ? 28 : 2)).current;
    const theme = native_1.useTheme();
    react_1.useEffect(() => {
        react_native_1.Animated.timing(fadeAnim, {
            toValue: !enabled ? 2 : 28,
            duration: 200,
            useNativeDriver: false,
        }).start();
    }, [enabled]);
    return (react_1.default.createElement(S.SwitchBackground, { accessibilityLabel: accessibilityLabel, accessibilityHint: accessibilityHint, testID: testID, accessibilityRole: "switch", accessibilityState: { checked: enabled }, isEnabled: enabled, underlayColor: theme.switch.disabledTrackColor, onPress: onChange },
        react_1.default.createElement(S.Switch, { as: react_native_1.Animated.View, isEnabled: enabled, style: [{ marginLeft: fadeAnim }], testID: `${testID} Toggle` })));
};
